import { Event } from '~/features/Schedule/mod.js';
import { SchedulePage } from '~/pages/SchedulePage/mod.js';
import { hydrateProps } from '~/ui/Hoc/mod.js';
import { ScheduleService } from '~/features/Schedule/mod.server.js';

export default hydrateProps({ event: Event.fromSanityRecord })(SchedulePage);

const EVENT_YEAR = process.env.SANITY_EVENT_YEAR;

export function getStaticProps() {
	return Promise.all([
		ScheduleService.fetchEventData(),
		import(`~/data/${EVENT_YEAR}`, { type: 'json' }),
	]).then(([{ result }, { default: yearData }]) => {
		// Split out the config data from the event data
		const { config = {}, ...event } = result[0];
		// console.table(event.sessions);

		return {
			props: {
				event,
				config,
				yearData,
			},
		};
	});
}
